import { Component, Input, OnChanges } from '@angular/core';
import { DdtHistoryItem } from 'src/app/api/models';
import { DdtService } from 'src/app/api/services';

// Elenco dello storico modifiche di un DDT (usato nella modale e nel dettaglio)
@Component({
  selector: 'app-ddt-history-table',
  templateUrl: './ddt-history-table.component.html',
})
export class DdtHistoryTableComponent implements OnChanges {
  @Input() ddtId?: number;

  histories: DdtHistoryItem[] = [];
  loading = false;

  constructor(private ddtService: DdtService) {}

  ngOnChanges() {
    if (!this.ddtId) return;
    this.loading = true;
    this.ddtService.ddtControllerFindHistory({ id: this.ddtId }).subscribe({
      next: res => {
        this.histories = res.data?.list ?? [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  // Valore leggibile di un cambio (anagrafica, contatto, elenco, data, testo)
  formatValue(v: any): string {
    if (v === null || v === undefined || v === '') return '—';
    if (Array.isArray(v)) return v.length ? v.map(x => this.formatValue(x)).join(', ') : '—';
    if (typeof v === 'object') {
      const label = [v.name, v.last_name].filter(Boolean).join(' ').trim();
      return label || JSON.stringify(v);
    }
    return String(v);
  }
}
